import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { MsalGuard, MsalInterceptor, MsalService } from '@azure/msal-angular';

const pathSegments = window.location.pathname.split('/').filter(Boolean);
const isViewEngagementRoute = pathSegments[0] === 'viewengagement';
const engagementId = pathSegments[1];
const countryId = pathSegments[2];

// Only persist the web-bench context when both route parameters exist.
// The normal /viewengagement/:id route has no countryId.
if (isViewEngagementRoute && engagementId && countryId) {
  localStorage.setItem('WBCountryId', countryId);
  localStorage.setItem('WBEngagementId', engagementId);
} else if (isViewEngagementRoute && engagementId) {
  localStorage.removeItem('WBCountryId');
  localStorage.removeItem('WBEngagementId');
}
/* This condition is for performance testing to modify bearer token */
if (!environment.isMsalEnabled) {
 // MsalGuard.prototype.canActivate = () => true;
  
  MsalInterceptor.prototype.intercept = (req, next) => {
    const access = localStorage.getItem('dbamsaltoken');
    req = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + environment.sampleToken
      }
    });
    return next.handle(req);
  };

  // MsalService.prototype.instance.acti = (): any => {
  //   if (!localStorage.getItem('dbamsaltoken')) return true;
  //   return {
  //     idToken: {
  //       scope: [],
  //       // other claims if required
  //     }
  //   };
  // };
}




if (environment.production) {  
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => { });
